module.exports = __WEBPACK_EXTERNAL_MODULE_https_d2olzqlzm6vpao_cloudfront_net_remote_home_remoteEntry_js_8ae6dfac__;